const methodColors = {
  GET: {
    base: 'bg-blue-600',
    hover: 'hover:bg-blue-700',
    focus: 'focus:ring-blue-400'
  },
  POST: {
    base: 'bg-green-600',
    hover: 'hover:bg-green-700',
    focus: 'focus:ring-green-400'
  },
  PUT: {
    base: 'bg-yellow-500',
    hover: 'hover:bg-yellow-600',
    focus: 'focus:ring-yellow-300'
  },
  PATCH: {
    base: 'bg-purple-600',
    hover: 'hover:bg-purple-700',
    focus: 'focus:ring-purple-400'
  },
  DELETE: {
    base: 'bg-red-600',
    hover: 'hover:bg-red-700',
    focus: 'focus:ring-red-400'
  },
  DEFAULT: {
    base: 'bg-gray-600',
    hover: 'hover:bg-gray-700',
    focus: 'focus:ring-gray-400'
  }
}

const ApiRouteIndicator = ({
  method = 'GET',
  route = '/',
  onClick,
  disabled = false,
  label
}) => {
  const methodUpper = method.toUpperCase()
  const colorSet = methodColors[methodUpper] || methodColors.DEFAULT

  const classes = [
    'w-16',
    'text-white',
    'px-2',
    'py-1',
    'rounded',
    'transition',
    'duration-150',
    'focus:outline-none',
    'focus:ring-2',
    'focus:ring-offset-2',
    colorSet.base,
    !disabled && colorSet.hover,
    !disabled && colorSet.focus,
    disabled && 'bg-gray-400 cursor-not-allowed opacity-60 pointer-events-none'
  ]
    .filter(Boolean)
    .join(' ')

  if (label) {
    return (
      <div className='flex flex-col text-sm font-mono'>
        <div>{label}</div>
        <div className='flex items-center space-x-3 text-sm font-mono my-2'>
          <button
            onClick={!disabled ? onClick : undefined}
            disabled={disabled}
            className={classes}
          >
            {methodUpper}
          </button>
          <span className='text-gray-600 dark:text-gray-600'>{route}</span>
        </div>
      </div>
    )
  }

  return (
    <div className='flex items-center space-x-3 text-sm font-mono my-2'>
      <button
        onClick={!disabled ? onClick : undefined}
        disabled={disabled}
        className={classes}
      >
        {methodUpper}
      </button>
      <span className='text-gray-600 dark:text-gray-600'>{route}</span>
    </div>
  )
}

export default ApiRouteIndicator
